import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Model from "./Model";
export class SpecialWarehousePrices extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      fieldTitle: 'id',
      formed: false,
      content: null,
      messages: []
    });
    _defineProperty(this, "Name", {
      fieldName: 'name',
      fieldTitle: 'Country',
      content: null,
      messages: []
    });
    _defineProperty(this, "Fulfillment", {
      fieldName: 'fulfillment',
      fieldTitle: 'Fulfillment',
      content: 0,
      messages: []
    });
    _defineProperty(this, "Upsell", {
      fieldName: 'upsell',
      fieldTitle: 'Upsell',
      content: 0,
      messages: []
    });
    _defineProperty(this, "Shipping", {
      fieldName: 'shipping',
      fieldTitle: 'Shipping',
      content: 0,
      messages: []
    });
    _defineProperty(this, "Return", {
      fieldName: 'returns',
      fieldTitle: 'Returns',
      content: 0,
      messages: []
    });
    _defineProperty(this, "Tax", {
      fieldName: 'tax',
      fieldTitle: 'Tax',
      content: 0,
      messages: []
    });
    _defineProperty(this, "Other", {
      fieldName: 'other',
      fieldTitle: 'Other',
      content: 0,
      messages: []
    });
    _defineProperty(this, "Actions", {
      value: 'mdi-pencil',
      event: null
    });
    _defineProperty(this, "editable", false);
  }
}
export default SpecialWarehousePrices;